import { AnalyticsPaymentStatusUpdateService } from '.';

export const unsubscribePaymentStatusUpdate = () => {
  if (AnalyticsPaymentStatusUpdateService) {
    AnalyticsPaymentStatusUpdateService.cancel();
  }
};
